import {
  ChangeDetectionStrategy,
  Component,
  Input,
  signal,
} from '@angular/core';
import { ButtonModule } from '@openng/optimus-ui/button';

@Component({
  selector: 'core-expandable-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule],
  template: `
    <div class="h-full relative grid grid-cols-[auto_1fr] gap-x-1 items-center">
      <p-button
        data-testid="toggleSidebar"
        [plain]="true"
        [rounded]="true"
        [text]="true"
        (click)="visible.set(!visible())"
        styleClass="p-button-rounded-small"
      >
        <span class="material-icons">{{
          visible() ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
        }}</span>
      </p-button>
      @if (visible()) {
        <div class="absolute top-0 left-full h-full ml-1 z-50 flex flex-col">
          <ng-content />
        </div>
      }
    </div>
  `,
  styles: [
    `
      :host {
        @apply h-full;
      }
    `,
  ],
})
export class ExpandableSidebarComponent {
  @Input()
  public set open(value: boolean) {
    this.visible.set(value);
  }
  public get open(): boolean {
    return this.visible();
  }
  protected visible = signal(false);
}
